import { makeConstantFactory } from 'utils/constantHelpers'
const makeConstant = makeConstantFactory('integrations')

export const FETCH_USER_PROFILE = makeConstant('FETCH_USER_PROFILE')
export const FETCH_USER_PROFILE_PENDING = makeConstant(
  'FETCH_USER_PROFILE_PENDING'
)
export const FETCH_USER_PROFILE_SUCCESS = makeConstant(
  'FETCH_USER_PROFILE_SUCCESS'
)
export const FETCH_USER_PROFILE_FAILED = makeConstant(
  'FETCH_USER_PROFILE_FAILED'
)

export const PATCH_USER_PROFILE = makeConstant('PATCH_USER_PROFILE')
export const PATCH_USER_PROFILE_SUCCESS = makeConstant(
  'PATCH_USER_PROFILE_SUCCESS'
)
export const PATCH_USER_PROFILE_FAILED = makeConstant(
  'PATCH_USER_PROFILE_FAILED'
)
export const PATCH_USER_PROFILE_PENDING = makeConstant(
  'FETCH_USER_PROFILE_PENDING'
)
